<div class="pending-claim-item">
    <div class="pending-claim-item__dossier">
        <div class="pending-claim-item__content">
            <div class="h3">{{ dossier.aard_schadegeval }}</div>
            <p>U bent begonnen met een schademelding. Wilt u die hier afronden? Dan gaan wij ermee aan de slag.</p>
        </div>
        <div class="pending-claim-item__btn">
            <div class="pending-claim-item__left">
                <a href="#" (click)="onVerwijderenClick()" class="link-secondary">Schademelding verwijderen</a>
            </div>
            <div class="pending-claim-item__right">
                <button class="btn btn--primary" (click)="onAfrondenClick()">Afronden</button>
            </div>
        </div>
    </div>
</div>
